import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { CertificateOutletType } from '..'
import OccurencesTable from '../../Occurrences/OccurencesTable'

const RncTable: React.FC = () => {
  const { search, appliedFilters, refresh, setLoadingHeader } = useOutletContext<CertificateOutletType>()

  return (
    <OccurencesTable
      search={search}
      appliedFilters={appliedFilters}
      refresh={refresh}
      onRefreshStart={() => setLoadingHeader(true)}
      onRefreshEnd={() => setLoadingHeader(false)}
    />
  )
}

export default RncTable
